import { createContext } from 'react';

const ModalDialogContext = createContext(void 0);

export { ModalDialogContext };
//# sourceMappingURL=ModalDialogContext.es.js.map
